module.exports = __webpack_public_path__ + "img/squishy-halloween-1.e566a560.webp";